import { AxiosError } from 'axios';

import { LEADS_API_URL } from '@/constants/apis';
import { apiManager } from '@/helpers/api.manager';
import { LeadsApiResponse } from '@/types/lead.type';
import { ApiResponse } from '@/types/response.type';

export interface GetLeadsParams {
  page?: number;
  limit?: number;
}

const getLeads = async (
  params: GetLeadsParams = {}
): Promise<ApiResponse<LeadsApiResponse>> => {
  try {
    const response = await apiManager.get(LEADS_API_URL, {
      headers: { 'Content-Type': 'application/json' },
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 20,
      },
    });

    if (response.status !== 200) {
      const error = response as unknown as AxiosError;
      return Promise.reject(error.response?.data);
    }

    return Promise.resolve(response.data);
  } catch (e) {
    return Promise.reject(e);
  }
};

export default getLeads;
